import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';
import { SettingsService } from '../services/settings.service';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'mapifyPrice'
})
export class MapifyPricePipe implements PipeTransform {
  constructor(private settings: SettingsService, private currencyPipe: CurrencyPipe) {}

  transform(productIds: string[], args?: any): any {
    const currency = this.settings.getCurrency();
    const prices = environment.mapify.prices;

    if (prices[currency]) {
      const price = productIds.reduce((acc, id) => acc + prices[currency][id], 0);

      return this.currencyPipe.transform(price, currency, 'symbol', '1.2');
    } else {
      throw new Error('Invalid price');
    }
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/pipes/mapify-price.pipe.ts